import { CoreUiException } from "./core-ui-exception";

/**
 * Occurrs when an http client is having network issues, and
 * has failed after several retries.
 */
export class NetworkConnectivityException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("NetworkConnectivityException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, NetworkConnectivityException.prototype);
    }
}
